<div class="job mb-3" (click)="openJob()" title="{{ job.nazov }}">
  <a><b>{{ job.nazov }}</b></a>
  <br>{{job.firma}}
  <br>{{job.lokalita}}
  <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
</div>
